import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

import { ArrowLeftIcon } from "../../Icons/Icons";
import {
  NAVIGATION_MENU_DRAWER_WIDTH,
  NAVIGATION_MENU_DRAWER_WIDTH_COLLAPSED,
  NAVIGATION_MENU_DRAWER_WIDTH_MOBILE,
} from "../config/constants";

/**
 * Component for rendering the drawer toggle button
 */
const DrawerToggleButton = ({ isSmall, isMenuOpen, handleDrawerClose, handleDrawerOpen }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        left: [
          isMenuOpen ? NAVIGATION_MENU_DRAWER_WIDTH_MOBILE - 25 : 25,
          isMenuOpen ? NAVIGATION_MENU_DRAWER_WIDTH - 25 : NAVIGATION_MENU_DRAWER_WIDTH_COLLAPSED - 25,
        ],
        opacity: [isMenuOpen ? 1 : 0, isMenuOpen ? 1 : 0, 1],
        top: "18px",
        zIndex: isSmall ? 1201 : 10,
        transition: (theme) => [
          theme.transitions.create(["left", "opacity"], {
            easing: theme.transitions.easing.easeOut,
            duration: 225,
          }),
          theme.transitions.create(["left", "opacity"], {
            easing: theme.transitions.easing.easeOut,
            duration: 225,
          }),
          theme.transitions.create("left"),
        ],
      }}
    >
      <IconButton
        className="drawer-toggle-button"
        onClick={isMenuOpen ? handleDrawerClose : handleDrawerOpen}
        sx={{
          display: !isMenuOpen && isSmall ? "none" : "",
          rotate: isMenuOpen ? "0deg" : "180deg",
          bgcolor: "common.white",
          padding: "6px",
          boxShadow: 1,
          "&:hover": {
            bgcolor: "common.white",
          },
        }}
      >
        <ArrowLeftIcon color="primary" sx={{ width: "26px", height: "26px" }} />
      </IconButton>
    </Box>
  );
};

export default DrawerToggleButton;
